<template>
    <div class="chars-list">
        <!-- 拼音标题 -->
        <div class="title-spell title" v-if="type === 'spell'">发音为 <span>{{content}}</span> 的汉字：</div>
        <!-- 部首标题 -->
        <div class="title-spell title" v-if="type === 'radical'">部首为 <span>{{content}}</span> 的汉字：</div>
        <!-- 列表 -->
        <div class="list-container">
            <!-- 汉字条目 -->
            <div class="chars-item clicks"
                 @click="$router.push('/charsDetail/'+item.id)"
                 v-for="item in charsList"
                 :key="item.id">{{item.content}}</div>
        </div>

    </div>
</template>

<script>
    import {GetCharsBySpell,GetCharsByRadical} from "@/request/chars";

    export default {
        name: "CharsList",
        created() {
            // TODO 1.被创建时指定导航栏类型
            this.$store.commit("nav/typeUpdate",3);
            // TODO 2.获取参数
            this.type = this.$route.params.type;
            this.content = this.$route.params.content;
            // TODO 3.获取数据
            // 3.1 如果是拼音
            if (this.type === "spell") {
                GetCharsBySpell({
                    spell:this.content
                }).then(res => {
                    if (res.code === 200){
                        this.charsList = res.data.list;
                    }
                })
            }
            // 3.2 如果是部首
            if (this.type === "radical"){
                GetCharsByRadical({
                    radical:this.content
                }).then(res => {
                    if (res.code === 200){
                        this.charsList = res.data.list;
                    }
                })
            }

        },
        data(){
            return{
                // 类型
                type:0,
                // 参数
                content:"",
                // 返回的汉字
                charsList:[]
            }
        }
    }
</script>

<style scoped lang="less">
    .chars-list{
        margin: 95px auto;
        width: 65%;
        /* 标题 */
        .title{
            font-size: 17px;
            font-weight: bold;
            span{
                color: #c04851;
            }
        }
        /* 列表 */
        .list-container{
            box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
            background-color: white;
            box-sizing: border-box;
            padding: 25px;
            margin-top: 25px;
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            /* 汉字 */
            .chars-item{
                padding: 5px;
                border: 1px solid #DCDFE6;
                margin-right: 25px;
                font-size: 17px;
                width: 25px;
                height: 25px;
                text-align: center;
                color: #606266;
                cursor: pointer;
                user-select: none;
                border-radius: 6px;
                margin-bottom: 20px;
                transition: all 0.3s;
            }
            /* 汉字被hover时 */
            .chars-item:hover{
                background-color: #BB4455;
                color: white;
            }
        }
    }
</style>